import { render, staticRenderFns } from "./PushConfig.vue?vue&type=template&id=60cfc6ca&scoped=true"
import script from "./PushConfig.vue?vue&type=script&lang=js"
export * from "./PushConfig.vue?vue&type=script&lang=js"
import style0 from "./PushConfig.vue?vue&type=style&index=0&id=60cfc6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cfc6ca",
  null
  
)

export default component.exports